export default function StatsSection() {
  const stats = [
    {
      number: '45%',
      title: 'ブランク復帰率',
      description: '登録スタッフの約半数がブランク、別業種からの復帰。安心のサポート体制で多くの方が職場復帰を実現しています。'
    },
    {
      number: '25%',
      title: '1年以内退職率',
      description: '業界平均を大きく下回る低い退職率。マッチング精度の高さと継続的なサポートの証です。'
    },
    {
      number: '100%',
      title: '地域最高時給保証',
      description: '同じ条件なら必ず地域最高時給をお約束。同一地域でトラストより高い時給があればご連絡ください。'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            数字で見るトラストの実績
          </h2>
          <p className="text-lg sm:text-xl text-gray-600">
            多くの方に選ばれ、信頼される理由があります
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="trust-card p-6 sm:p-8 rounded-2xl text-center">
              <div className="text-4xl sm:text-5xl font-bold text-primary mb-4">
                {stat.number}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
                {stat.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-700">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}